"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Collapse = require("./Collapse");
Object.keys(_Collapse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Collapse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Collapse[key];
    }
  });
});